/**
 * 가격 비공개 계약 장지 시설 id. 목록 본체는 goi_common 으로 옮겼다.
 * parlor 도 같은 목록을 써야 해서(지역 페이지 장지 카드) 앱 밖으로 뺐다.
 *
 * 이 파일은 기존 import 경로(`@/constants/facility/excludeFacilities`,
 * 그리고 pages/facilities/[id] 의 re-export)를 유지하기 위해 남긴다.
 */
export { excludeFacilities } from "goi_common";
